import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { Alert, Button, Container } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import BackgroundImages from 'v2/common/Background/BackgroundImages';
import Input from 'v2/form/Input/Input';
import restFactory from 'v2/utils/restFactory';
import * as yup from 'yup';

interface ProposalTokenResponse {
  token: string;
}

interface TokenResponseProposalForm {
  userId: number | undefined;
  proposalId: number | undefined;
}

const schema = yup.object().shape({
  userId: yup.number().required('Required'),
  proposalId: yup.number().required('Required'),
});

const TokenResponseProposal = () => {
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<TokenResponseProposalForm>({
    mode: 'onChange',
    defaultValues: { userId: undefined, proposalId: undefined },
    resolver: yupResolver(schema),
  });

  const onSubmit = async (formData: TokenResponseProposalForm) => {
    try {
      setLoading(true);
      const response = await restFactory.get<ProposalTokenResponse>(
        `/dj/api/v1/proposal/${formData.proposalId}/generate_token/`,
        {
          user_id: formData.userId,
        }
      );
      setToken(response.token);
      setLoading(false);
    } catch (error) {
      toast.error(error as AxiosError);
      setLoading(false);
      setToken('');
    }
  };
  return (
    <Container className="mt-4 fix-bg-images" fluid="xl">
      <BackgroundImages showTopImage={false} />
      <h1>Proposal token</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex w-100">
          <div className="form-group w-50 mr-2">
            <Input
              label="Proposal ID"
              type="number"
              register={register('proposalId', { required: true })}
              error={errors?.proposalId && 'Must be a valid number'}
              autoComplete="off"
              required={true}
              step="1"
              showErrorBorder={!!errors?.proposalId?.message}
            />
          </div>
          <div className="form-group w-50 ml-2">
            <Input
              label="User ID"
              type="number"
              register={register('userId', { required: true })}
              error={errors?.userId && 'Must be a valid number'}
              autoComplete="off"
              required={true}
              step="1"
              showErrorBorder={!!errors?.userId?.message}
            />
          </div>
        </div>
        <Button variant="primary" type="submit" disabled={loading}>
          {loading ? 'Loading...' : 'Submit'}
        </Button>
      </form>
      {token ? (
        <Alert
          className="mt-3"
          variant="primary"
          onClose={() => {
            setToken('');
            reset();
          }}
          dismissible
        >
          <p className="mb-1">Use this URL to respond to a proposal:</p>
          <strong>
            {window.location.origin}/proposal/token/{token}
          </strong>
        </Alert>
      ) : null}
    </Container>
  );
};

export default TokenResponseProposal;
